import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

import {AggregateRowComponent} from './aggregates-row.component';
import {AggregatesComponent} from './aggregates.component';
import {AggregatesService} from './aggregates.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    UiModule,
    ModalModule,
    PipesModule
  ],
  declarations: [
    AggregatesComponent,
    AggregateRowComponent
  ],
  exports: [
    AggregatesComponent,
    AggregateRowComponent
  ]
})

export class AggregatesModule {
  public static forRoot(): ModuleWithProviders<AggregatesModule> {
    return {
      ngModule: AggregatesModule,
      providers: [
        AggregatesService
      ]
    };
  }
}
